import React, { useState, useEffect } from 'react';
import './RegisterNow.css';
import { useNavigate, useLocation } from 'react-router-dom';

const countries = [
  { code: '+1' },
  { code: '+91' },
  { code: '+44' },
  { code: '+61' },
  { code: '+81' },
  { code: '+971' },
];

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
};

const RegisterNow = () => {
  const [successMessage, setSuccessMessage] = useState('');
  const [serverError, setServerError] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);


  const [form, setForm] = useState({
    name: '',
    email: '',
    countryCode: '+91',
    number: '',
    consent: false,
    webinarId: '',
    webinarName: '',
  });

  const [errors, setErrors] = useState({});

  const webinars = [
    {
      id: '1',
      title: 'Break into Product Management Without an MBA',
      status: 'upcoming',
      outcomes: [
        'Step-by-step entry guide for non-tech & tech folks',
        'Real frameworks used in top startups',
        'Learn directly from product leaders',
      ],
    },
    {
      id: '2',
      title: 'How to Land Your Dream Job in 2025 with Proven Career Strategies',
      status: 'ongoing',
      outcomes: [
        'Proven strategies to bypass common hiring blocks',
        'Career roadmap tailored to today’s job market',
        'Real success stories from placed candidates',
      ],
    },
    {
      id: '3',
      title: 'Learn Data Analytics Basics and Tools to Launch Your Career',
      status: 'upcoming',
      outcomes: [
        'Understand basics of data analytics in 60 mins',
        'Learn tools like Excel, SQL & BI hands-on',
        'Get starter project & certification insights',
      ],
    },
    {
      id: '4',
      title: 'Beat the ATS: Build a Resume That Gets Shortlisted',
      status: 'ongoing',
      outcomes: [
        'Create an ATS-friendly resume in minutes',
        'Understand why 90% resumes get rejected',
        'Get insider tips from recruiters',
      ],
    },
    {
      id: '5',
      title: 'Start Your Business Analyst Career with Real Industry Skills',
      status: 'upcoming',
      outcomes: [
        'Learn business process mapping, documentation & tools',
        'Crack entry-level BA interviews with confidence',
        'Explore hiring trends & case studies',
      ],
    },
    {
      id: '6',
      title: 'Master Interview Skills with Real-Time Mock Sessions',
      status: 'ongoing',
      outcomes: [
        'Master real-time interview scenarios',
        'Confidence-building hacks from industry experts',
        'Practice with feedback from ex-FAANG, Big4 mentors',
      ],
    },
    {
      id: '7',
      title: 'Get Started in QA Testing: Manual + Automation Essentials',
      status: 'upcoming',
      outcomes: [
        'Learn business process mapping, documentation & tools',
        'Crack entry-level BA interviews with confidence',
        'Explore hiring trends & case studies',
      ],
    },
    {
      id: '8',
      title: 'Career Toolkit: One-Stop Platform for Resume, Jobs & Mentorship',
      status: 'ongoing',
      outcomes: [
        'One dashboard for jobs, resumes, assessments',
        'Stop wasting time on 10+ platforms',
        'Learn how to track and apply like a pro',
      ],
    },
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = 'Name is required';
    if (!form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      errs.email = 'Valid email is required';
    if (!form.number.match(/^[0-9]{7,15}$/))
      errs.number = 'Enter valid phone number';
    if (!form.consent) errs.consent = 'You must agree to terms';
    if (!form.webinarId) errs.webinarId = 'Select a webinar';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  setLoading(true); // show loader

  try {
    const response = await fetch('https://skillshap.com/register-webinar', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });

    const result = await response.json();
if (response.ok) {
  alert(result.alert || 'Registered successfully!');
  setSuccessMessage('');
      setServerError('');
      setForm({
        name: '',
        email: '',
        countryCode: '+91',
        number: '',
        consent: false,
        webinarId: '',
        webinarName: '',
      });
      setTimeout(() => {
        setSuccessMessage('');
        navigate('/');
      }, 3000);
    } else {
      setSuccessMessage('');
      setServerError(result.error || result.detail || 'Registration failed.');
    }
  } catch (error) {
    console.error('Error:', error);
    setSuccessMessage('');
    setServerError('Something went wrong. Try again later.');
  } finally {
    setLoading(false); // hide loader
  }
};

  const upcoming = webinars.filter((w) => w.status === 'upcoming');
  const ongoing = webinars.filter((w) => w.status === 'ongoing');

  return (
    <>
    {loading && (
  <div className="loader-overlay">
    <div className="loader"></div>
  </div>
)}

      <br /><br /><br /><br /><br /><br />
      <div className="webinar-section1">
        <ScrollToTop />
        <div className="webinar-register-container">
          <form className="webinar-register-form" onSubmit={handleSubmit}>
            <h2>Register For Webinar</h2>

            <label>
              Name
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter Your Full Name"
                required
              />
              {errors.name && <span className="webinar-error">{errors.name}</span>}
            </label>

            <label>
              Email
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter Your Email"
                required
              />
              {errors.email && <span className="webinar-error">{errors.email}</span>}
            </label>

            <label>
              Mobile Number
              <div className="webinar-phone-group">
                <select
                  name="countryCode"
                  value={form.countryCode}
                  onChange={handleChange}
                >
                  {countries.map((c) => (
                    <option key={c.code} value={c.code}>
                      {c.code}
                    </option>
                  ))}
                </select>
                <input
                  type="tel"
                  name="number"
                  placeholder="Phone Number"
                  value={form.number}
                  onChange={handleChange}
                  required
                />
              </div>
              {errors.number && <span className="webinar-error">{errors.number}</span>}
            </label>

            <label>
              Select Webinar
              <select
                name="webinarId"
                value={form.webinarId}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selectedWebinar = webinars.find((w) => w.id === selectedId);
                  setForm((prev) => ({
                    ...prev,
                    webinarId: selectedId,
                    webinarName: selectedWebinar ? selectedWebinar.title : '',
                  }));
                }}
                required
              >
                <option value="">-- Choose a webinar --</option>
                {webinars.map((w) => (
                  <option key={w.id} value={w.id}>
                    {w.title}
                  </option>
                ))}
              </select>
              {errors.webinarId && (
                <span className="webinar-error">{errors.webinarId}</span>
              )}
            </label>

            <div className="webinar-checkbox-wrapper">
              <input
                type="checkbox"
                name="consent"
                checked={form.consent}
                onChange={handleChange}
                required
              />
              <span>I agree to receive messages and accept the terms</span>
            </div>
            {errors.consent && (
              <span className="webinar-error">{errors.consent}</span>
            )}

            <button type="submit" className="webinar-submit-button">
              REGISTER
            </button>
            {successMessage && <p className="webinar-success">{successMessage}</p>}
            {serverError && <p className="webinar-error">{serverError}</p>}
          </form>
        </div>

        <div className="webinar-block">
          <h3>Ongoing Webinars</h3>
          <div className="webinar-track-wrapper">
            <div className="webinar-track">
              {ongoing.map((w) => (
                <div key={w.id} className="webinar-card">
                  <h4>{w.title}</h4>
                  <ul>
                    {w.outcomes.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="webinar-block">
          <h3>Upcoming Webinars</h3>
          <div className="webinar-track-wrapper">
            <div className="webinar-track">
              {upcoming.map((w) => (
                <div key={w.id} className="webinar-card">
                  <h4>{w.title}</h4>
                  <ul>
                    {w.outcomes.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterNow;